export default __webpack_public_path__ + "static/media/snake.1cd141e2.png";